<template>
  <div id="container">
    <div id="title">
      <h1>Liste des utilisateurs ({{ pagination.totalCount }})</h1>
    </div>
    <b-modal
      v-model="showMails"
      title="Détails des mails envoyés"
      hide-footer
      size="sm"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <history-mail :id="showMailsId"></history-mail>
    </b-modal>
    <div id="content">
      <div class="block-flat">
        <b-row>
          <b-col xl="4" lg="12" md="12" sm="12" cols="12" class="no-padding">
            <b-button
              @click="goToNewUser()"
              variant="primary"
              block
              class="btn-auto"
            >
              <font-awesome-icon icon="plus"></font-awesome-icon> Nouvel
              utilisateur
            </b-button>
          </b-col>
          <b-col
            xl="8"
            lg="12"
            md="12"
            sm="12"
            cols="12"
            class="no-padding text-right boite-outils"
          >
            <div class="input-search">
              <b-form-input
                @keyup.enter="runSearch()"
                v-model="searchText"
                placeholder="Recherche"
              ></b-form-input>
            </div>
            <b-button
              @click="runSearch()"
              variant="success"
              block
              class="btn-auto mr-2 search-liste"
            >
              <font-awesome-icon icon="search"></font-awesome-icon
              ><span>Rechercher</span>
            </b-button>
            <b-button
              @click="clearSearch()"
              variant="danger"
              block
              class="btn-auto mr-2 search-liste"
            >
              <font-awesome-icon icon="times"></font-awesome-icon>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
            <div class="listing-demandes">
              <table class="table-demandes table-users">
                <header-grid
                  @change="applyFilter($event)"
                  :headers="headers"
                  :searchSort="searchSort"
                ></header-grid>
                <tbody>
                  <tr
                    v-for="user in users"
                    :key="user.id"
                    :class="{ 'disabled-user-row': !!user.disabled }"
                  >
                    <td class="text-center link-detail">
                      <div class="avatar-users">
                        <div class="container-avatar">
                          <b-img
                            v-if="user.picture == null"
                            img
                            src="../img/avatar-client.png"
                            alt="user-img"
                          />
                          <b-img-lazy
                            v-else
                            img
                            :src="user.picture"
                            alt="user-img"
                            class="img-circle"
                          />
                          <label
                            :class="
                              user.id > 999 ? 'change small-change' : 'change'
                            "
                          >
                            {{ user.id }}</label
                          >
                        </div>
                      </div>
                      <b> </b>
                      <div
                        class="hover-thumb"
                        v-if="
                          (userConnected &&
                            userConnected.roles.includes('ROLE_GUICHET')) ||
                          userConnected.roles.includes('ROLE_ADMIN')
                        "
                        @click="goToUser(user.id)"
                      >
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </div>
                    </td>
                    <td class="text-center">{{ user.firstName }}</td>
                    <td class="text-center">{{ user.lastName }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.phone }}</td>
                    <td>
                      <span
                        v-if="user.roles && user.roles.includes('ROLE_ADMIN')"
                      >
                        Administrateur
                      </span>
                      <span
                        v-if="user.roles && user.roles.includes('ROLE_USER')"
                      >
                        Opérateur
                      </span>
                      <span
                        v-else-if="
                          user.roles &&
                          user.roles.includes('ROLE_GESTIONNAIRE') &&
                          !user.roles.includes('ROLE_GUICHET')
                        "
                      >
                        Gestionnaire de voirie
                      </span>
                      <span
                        v-else-if="
                          user.roles &&
                          user.roles.includes('ROLE_GUICHET') &&
                          !user.roles.includes('ROLE_GESTIONNAIRE')
                        "
                      >
                        Guichet
                      </span>
                      <span
                        v-else-if="
                          user.roles &&
                          user.roles.includes('ROLE_GUICHET') &&
                          user.roles.includes('ROLE_GESTIONNAIRE')
                        "
                      >
                        Gestionnaire de voirie et Guichet
                      </span>
                      <span
                        v-else-if="
                          user.roles && user.roles.includes('ROLE_SOUSTRAITANT')
                        "
                      >
                        Sous traitant
                      </span>
                      <span v-else>
                        <span
                          v-if="
                            user.roles && !user.roles.includes('ROLE_ADMIN')
                          "
                        >
                          Pas de role
                        </span>
                      </span>
                    </td>
                    <td>
                      <div v-if="user.managerPerimeter !== null">
                        {{ user.managerPerimeter }}
                      </div>
                    </td>
                    <td>
                      <div v-if="user.ticketOfficePerimeter !== null">
                        {{ user.ticketOfficePerimeter }}
                      </div>
                    </td>
                    <td>
                      <div v-if="user.operatorPerimeter !== null">
                        {{ user.operatorPerimeter }}
                      </div>

                      <div v-if="user.sousTraitantPerimeter !== null">
                        {{ user.sousTraitantPerimeter }}
                      </div>
                    </td>
                    <td>
                      <div v-if="user.pole !== null">
                        {{ user.pole }}
                      </div>
                    </td>
                    <td>
                      <div v-if="user.last_login !== null">
                        {{ user.last_login }}
                      </div>
                    </td>
                    <td class="text-right lst-actions">
                      <b-button
                        v-b-tooltip.hover
                        title="Voir le profil"
                        @click="goToUser(user.id)"
                        variant="warning"
                        class="mr-2"
                        size="sm"
                      >
                        <font-awesome-icon
                          v-if="
                            (userConnected &&
                              userConnected.roles.includes('ROLE_GUICHET')) ||
                            userConnected.roles.includes('ROLE_ADMIN')
                          "
                          icon="pencil-alt"
                        ></font-awesome-icon>
                        <font-awesome-icon
                          v-else
                          icon="eye"
                        ></font-awesome-icon>
                      </b-button>
                      <b-button
                        v-b-tooltip.hover
                        title="Réinitialiser le mot de passe"
                        v-if="
                          (userConnected &&
                            userConnected.roles.includes('ROLE_GUICHET')) ||
                          userConnected.roles.includes('ROLE_ADMIN')
                        "
                        :disabled="!!user.disabled"
                        @click="resendPassword(user)"
                        variant="info"
                        class="mr-2"
                        size="sm"
                      >
                        <font-awesome-icon icon="key"></font-awesome-icon>
                      </b-button>
                      <b-button
                        v-b-tooltip.hover
                        :title="user.disabled ? 'Activer le compte utilisateur' : 'Désactiver le compte utilisateur'"
                        v-if="
                          userConnected &&
                          userConnected.roles.includes('ROLE_ADMIN')
                        "
                        :disabled="userConnected && userConnected.id === user.id"
                        @click="askToggleUserDisabled(user)"
                        :variant="user.disabled ? 'success' : 'secondary'"
                        class="mr-2"
                        size="sm"
                      >
                        <font-awesome-icon
                          :icon="user.disabled ? 'check' : 'ban'"
                        ></font-awesome-icon>
                      </b-button>
                      <!-- <b-button
                        v-b-tooltip.hover
                        title="Historique des mails"
                        v-if="
                          (userConnected &&
                            
                            userConnected.roles.includes('ROLE_GUICHET')) ||
                            userConnected.roles.includes('ROLE_ADMIN')
                        "
                        @click="showHistory(user.id)"
                        variant="info"
                        class="mr-2"
                        size="sm"
                      >
                        <font-awesome-icon
                          icon="paper-plane"
                        ></font-awesome-icon>
                      </b-button> -->
                      <b-button
                        v-b-tooltip.hover
                        title="Supprimer l'utilisateur"
                        v-if="
                          (userConnected &&
                            userConnected.roles.includes('ROLE_ADMIN')) ||
                          !!userConnected.allowDelete
                        "
                        @click="askDeleteUser(user)"
                        variant="danger"
                        size="sm"
                      >
                        <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="pagination">
              <b-pagination
                v-model="pagination.current"
                :total-rows="pagination.totalCount"
                :per-page="pagination.numItemsPerPage"
                aria-controls="my-table"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
import headergrid from "../components/HeaderGrid.vue";
import historyMails from "../components/historyMails.vue";
import router from "../router/index.js";
export default {
  name: "Users",
  data: () => ({
    showMails: false,
    showMailsId: null,
    headers: [
      {
        name: "id",
        code: "s.id",
        width: "70px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Prénom",
        code: "s.first_name",
        width: "80px",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Nom",
        code: "s.last_name",
        width: "70px",
        open: false,
        sortable: true,
        filterable: false,
        dir: "ASC",
        filter: null,
        filterData: null,
      },

      {
        name: "Courriel",
        code: "s.email",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Téléphone",
        code: "s.phone",
        open: false,
        sortable: true,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "role",
        code: "",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "gestionnaire",
        code: "mp.libelle",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Guichet",
        code: "top.libelle",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Société",
        code: "top.libelle",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Pôle",
        code: "pole.libelle",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "Dernière connexion",
        code: "last_login",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
      {
        name: "actions",
        width: "165px",
        open: false,
        sortable: false,
        filterable: false,
        dir: null,
        filter: null,
        filterData: null,
      },
    ],
    searchText: "",
    searchFilter: [],
    searchSort: "s.last_name",
    searchDir: "ASC",
    userToRemove: null,
  }),
  watch: {
    "pagination.current": function () {
      this.runSearch();
    },
  },
  components: {
    "header-grid": headergrid,
    "history-mail": historyMails,
  },
  methods: {
    showHistory(id) {
      this.showMailsId = id;
      this.showMails = true;
    },
    clearSearch() {
      this.searchText = "";
      (this.searchFilter = {}),
        (this.searchSort = "s.last_name"),
        (this.searchDir = "ASC");
      this.headers.forEach((element) => {
        if (element.code == this.searchSort) {
          element.dir = this.searchDir;
        }
      });
      this.runSearch();
    },
    applyFilter(header) {
      this.headers.forEach((element) => {
        if (element.name != header.name) {
          element.dir = "";
        } else {
          element.open = false;
        }
      });

      if (header.filter && header.filter != null && header.filter != "") {
        this.searchFilter[header.code] = header.filter;
      }
      if (header.dir && header.dir != "" && header.dir != null) {
        this.searchSort = header.code;
        this.searchDir = header.dir;
      }

      this.runSearch();
    },

    runIfCancelClicked() {},
    runIfOkClicked() {
      this.deleteUser(this.userToRemove);
    },
    askDeleteUser(user) {
      this.userToRemove = user;
      Vue.prototype.$awn.confirm(
        "Voulez vous vraiment supprimer cet utilisateur ?",
        this.runIfOkClicked,
        this.runIfCancelClicked
      );
    },
    askToggleUserDisabled(user) {
      const actionLabel = user.disabled ? "activer" : "désactiver";
      Vue.prototype.$awn.confirm(
        "Voulez vous vraiment " + actionLabel + " cet utilisateur ?",
        () => {
          this.toggleUserDisabled({
            id: user.id,
            disabled: !user.disabled,
          });
        },
        this.runIfCancelClicked
      );
    },
    runSearch() {
      let page =
        this.pagination && this.pagination.current
          ? this.pagination.current
          : 1;
      this.getUsers({
        page: page,
        searchText: this.searchText,
        searchSort: this.searchSort,
        searchDir: this.searchDir,
        searchFilter: this.searchFilter,
      });
    },
    goToNewUser() {
      router.push({ name: "NewUser" });
    },
    goToUser(id) {
      let encrypted = this.$aes.encrypt(id.toString());
      router.push({ name: "User", params: { id: encrypted } });
    },

    resendPassword(user) {
      if (user && user.disabled) {
        Vue.prototype.$awn.alert("Aucun compte associé à cet identifiant");
        return;
      }

      Vue.prototype.$awn.confirm(
        "Voulez vous vraiment renvoyer un lien de réinitialisation de mot de passe ?",
        function () {
          Vue.axios
            .post(window.urlapi + "password", { email: user.email })
            .then((response) => {
              if (response.data.success == true) {
                Vue.prototype.$awn.success(response.data.message.toString());
              }
            });
        },
        function () {}
      );
    },
    ...Vuex.mapActions("User", ["getUsers", "deleteUser", "toggleUserDisabled"]),
  },
  computed: {
    ...Vuex.mapGetters("User", ["users", "pagination"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
  mounted() {
    this.runSearch();
  },
};
</script>

<style>
.disabled-user-row td {
  font-style: italic;
}
</style>
